<template>
<div style="width:1300px;margin:0 auto;padding:80px 0 0px 0;margin-bottom:60px;position:relative;color:#fff;cursor:pointer"  @click="goMore">
  <div class="titleStyle" :style="titleStyle">
    <span style="font-size:97px;font-weight:700">{{solutionObj.sub_name}}</span>
  </div>
  <img src="@/views/solution/images/redRight.png" alt="" srcset="" style="width:23px;position:absolute;bottom:-28px;left:390px">
  <div style="position:absolute;display:block;bottom:-40px;font-size:18px;letter-spacing:1px;font-weight:300;left:270px;border-bottom:1px solid #3f4354;padding-bottom:5px;width:970px;">
    <span style="color:#fcfcfc;">解决方案</span>
    <span style="display:block;float:right;font-weight:200;color:#fcfcfc">+ MORE</span>
  </div>
</div>
</template>
<script>
export default {
  name: 'App',
   components:{
 
  },
  props: {
    solutionObj: {
      type: Object,
      default: function() {
        return {}
      }
    },
    
    titleStyle: {
      type: String,
      default: ''
    },
    subTitleStyle: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: 'Solution'
    },
    subTitle: {
      type: String,
      default: '解决方案'
    }
  },
  data() {  
    return {  
     images: [  
       
      ] 
    };  
  }, 

  methods:{
    goMore() {
      this.$router.push({ path: '/solution',query:{id:this.solutionObj.id,model_type:this.solutionObj.model_type} })
    },
  }
}
</script>
<style lang="scss" scoped>
.titleStyle {
  height:100%;display:inline-block;width:390px;
}
.subTitleStyle {
  position:relative;display:inline-block;width:910px;height:95px;border-bottom:1px solid #000;
}
</style>
